import { render, staticRenderFns } from "./addeditcompany.vue?vue&type=template&id=80054dd8&scoped=true&"
import script from "./addeditcompany.vue?vue&type=script&lang=js&"
export * from "./addeditcompany.vue?vue&type=script&lang=js&"
import style0 from "./addeditcompany.vue?vue&type=style&index=0&id=80054dd8&lang=less&scoped=true&"
import style1 from "./addeditcompany.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80054dd8",
  null
  
)

export default component.exports